import {FC} from 'react'
import styles from './Modal.module.scss'

interface Props{
  children?: React.ReactNode;
}

export const ModalHeader: FC<Props> = ({children}) => {
  return (
    <>
        <div className={styles.modalHeader}>
            <div className={styles.modalHeaderContent}>
                {children}
            </div>
        </div>
    </>
  )
}